export type Prng = (max?: number) => number;

export function makePrng(seed: number): Prng {
  let state = seed >>> 0;
  return (max?: number): number => {
    state = (state + 0x6d2b79f5) >>> 0;
    let t = state;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    const v = ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    if (max === undefined) return v;
    return Math.floor(v * max);
  };
}

export function pickFrom<T>(prng: Prng, items: readonly T[]): T {
  if (items.length === 0) throw new Error('pickFrom: empty items array');
  const idx = prng(items.length);
  const item = items[idx];
  if (item === undefined) throw new Error('pickFrom: invalid index');
  return item;
}

export function shuffle<T>(prng: Prng, items: readonly T[]): T[] {
  const out: T[] = [...items];
  for (let i = out.length - 1; i > 0; i -= 1) {
    const j = prng(i + 1);
    const tmp = out[i];
    if (tmp !== undefined && out[j] !== undefined) {
      out[i] = out[j];
      out[j] = tmp;
    }
  }
  return out;
}
